module.exports = __webpack_public_path__ + "img/risk.0b58d255.svg";